<template>
  <multiselect
    :options="buildings"
    :multiple="false"
    :show-labels="false"
    :searchable="true"
    :loading="isSearching !== 0"
    :internal-search="false"
    :clear-on-select="false"
    :close-on-select="true"
    :placeholder="$t('building_page.plzEnterKeywords')"
    track-by="id"
    :label="label"
    v-model="selectedBuilding"
    @search-change="onType"
    @select="onSelect"
  >
    <span slot="noResult">找不到建築物</span>
  </multiselect>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
import gql from 'graphql-tag';
import Multiselect from 'vue-multiselect';

export default {
  props: ['districtId'],
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedBuilding: null,
      buildings: [],
      query: null,
      isSearching: 0,
    };
  },
  computed: {
    label() {
      return this.$i18n.locale === 'en' ? 'nameEn' : 'nameZh';
    },
  },
  watch: {
    buildings() {
      console.log(this.buildings);
      this.$nextTick(() => {
        if (this.$i18n.locale === 'gb') {
          //window.changeToGb();
        }
      });
    },
  },
  apollo: {
    $client: 'building',
    buildings: {
      fetchPolicy: 'network-only',
      query: gql`
        query ($districtId: ID, $query: String) {
          buildings(districtId: $districtId, nameSearch: $query) {
            id
            nameEn
            nameZh
          }
        }
      `,
      variables() {
        return {
          districtId: this.districtId,
          query: this.query,
        };
      },
      update(data) {
        return !Array.isArray(data.buildings) ? [] :
          data.buildings.map(b => ({
            ...b,
            nameZh: window.convertStr(b.nameZh, this.$i18n.locale),
            nameEn: b.nameEn
              .trim()
              .toLowerCase()
              .replace(/\s(.)/g, $1 => $1.toUpperCase())
              .replace(/^(.)/g, $1 => $1.toUpperCase()),
          }));
      },
      skip() {
        return !this.districtId && !this.query;
      },
      loadingKey: 'isSearching',
    },
  },
  methods: {
    onSelect(selectedOption) {
      const urlName = selectedOption.nameEn
        .trim()
        .toLowerCase()
        .replace(/\s(.)/g, $1 => $1.toUpperCase())
        .replace(/^(.)/g, $1 => $1.toUpperCase())
        .replace(/[!*'();:@&=+$,/?%#[\] ]/g, '-');
      this.$router.push(`/details/${selectedOption.id}/${urlName}`);
    },
    onType(query) {
      this.query = window.convertStr(query, 'zh-HK');
    },
  },
};
</script>

<style>
.building-search .multiselect__tags {
  height: 34px;
  min-height: 34px;
  border: 1px solid #ccc;
  padding: 5px 40px 0 8px;
}
.multiselect__single {
  font-size: 14px;
  padding-top: 5px;
}

.multiselect__input, .multisele_ct_single {
  font-size: 14px;
  padding-top: 6px;
  margin-bottom: 0px;  
}

.multiselect__select { 
  height: 34px;
}

.multiselect__option--highlight {
  background: #1e90ff;
  outline: none;
  color: #fff;
}
</style>
<style scoped>
</style>
